<!-- notifications.component.html -->
<div class="notifications-container" [class.mobile]="isMobile">
  <div class="notifications-header">
    <h2>Tus alertas</h2>
    <button (click)="onClose()" class="close-button">
      <fa-icon [icon]="faTimes"></fa-icon>
    </button>
  </div>
  
  <div class="notifications-list">
    <!-- Notificación tipo "Nuevo negocio en tu zona" -->
    <ng-container *ngFor="let notification of notifications">
      <div class="notification-item"
      [ngClass]="{'read-notification': !notification.viewed}"
      (click)="goToOrderDetail(notification)"
      >
        <div class="notification-title-content">
          <div class="notification-title">
            <ng-container [ngSwitch]="notification.status">
              <h3 class="notification-title" *ngSwitchCase="'Creado'">Tu pedido ha sido creado</h3>
              <h3 class="notification-title" *ngSwitchCase="'En curso'">Tu pedido está en curso</h3>
              <h3 class="notification-title" *ngSwitchCase="'Pendiente pago'">Tu pedido está pendiente de pago</h3>
              <h3 class="notification-title" *ngSwitchCase="'Entregado'">Tu pedido ha sido entregado</h3>
              <h3 class="notification-title" *ngSwitchCase="'Cancelado'">Tu pedido ha sido cancelado</h3>
              <h3 class="notification-title" *ngSwitchDefault>Actualización de pedido</h3>
            </ng-container>
          </div>
          <div class="notification-date">
            <p>
              {{ notification.createdAt | date:'dd/MM/yy' }}
            </p>
          </div>
        </div>
        
        <div class="notification-content">
          <div class="notification-icon" [ngStyle] = "{'background-color': getStatusColor(notification.status)}" [ngSwitch]="notification.status">
            <svg *ngSwitchCase="'Pendiente pago'" width="24" height="24" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.27 5.9599L10 11.0099L18.73 5.9599M10 21.0799V10.9999M19 14.9999V6.9999C18.9996 6.64918 18.9071 6.30471 18.7315 6.00106C18.556 5.69742 18.3037 5.44526 18 5.2699L11 1.2699C10.696 1.09437 10.3511 1.00195 10 1.00195C9.64893 1.00195 9.30404 1.09437 9 1.2699L2 5.2699C1.69626 5.44526 1.44398 5.69742 1.26846 6.00106C1.09294 6.30471 1.00036 6.64918 1 6.9999V14.9999C1.00036 15.3506 1.09294 15.6951 1.26846 15.9987C1.44398 16.3024 1.69626 16.5545 2 16.7299L9 20.7299C9.30404 20.9054 9.64893 20.9979 10 20.9979C10.3511 20.9979 10.696 20.9054 11 20.7299L18 16.7299C18.3037 16.5545 18.556 16.3024 18.7315 15.9987C18.9071 15.6951 18.9996 15.3506 19 14.9999Z" stroke="#1B1B1A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <svg *ngSwitchCase="'En curso'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 16V3H1V16H16ZM16 16H23V11L20 8H16V16ZM8 18.5C8 19.8807 6.88071 21 5.5 21C4.11929 21 3 19.8807 3 18.5C3 17.1193 4.11929 16 5.5 16C6.88071 16 8 17.1193 8 18.5ZM21 18.5C21 19.8807 19.8807 21 18.5 21C17.1193 21 16 19.8807 16 18.5C16 17.1193 17.1193 16 18.5 16C19.8807 16 21 17.1193 21 18.5Z" stroke="#1B1B1A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <svg *ngSwitchCase="'Entregado'" width="24" height="24" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.5 6V19H3.5V6M10.5 10H14.5M1.5 1H23.5V6H1.5V1Z" stroke="#1B1B1A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <svg *ngSwitchCase="'Cancelado'" width="24" height="24" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.5 8L8.5 14M8.5 8L14.5 14M7.36 1H15.64L21.5 6.86V15.14L15.64 21H7.36L1.5 15.14V6.86L7.36 1Z" stroke="#1B1B1A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="notification-message">
          <div class="order-info">
              <p class="order-number">Pedido #{{ notification.orderId | slice: -5 }}...</p>
              <p class="order-products">{{ notification.products }} producto{{ notification.products !== 1 ? 's' : '' }}</p>
              <p class="order-total">{{ formatCurrency(notification.total / 100) }}</p>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    
    
    <!-- Estado cuando no hay notificaciones -->
    <div *ngIf="notifications.length === 0" class="empty-notifications">
      <div class="empty-icon">
        <fa-icon [icon]="faBellSlash"></fa-icon>
      </div>
      <h3>¡Aún no tienes notificaciones!</h3>
    </div>
  </div>
</div>